// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topic__comment__mark-as-done-button__body{display:inline-block;background-color:#06860a;box-shadow:#000 0 0 4px;padding:2px 5px;font-size:12px;color:#f9f9f9;border-radius:3px;line-height:100%;cursor:pointer;transition:background-color ease-in-out 250ms}.topic__comment__mark-as-done-button__body:hover{background-color:#0da912}", ""]);
// Exports
module.exports = exports;
